import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-players-list',
  templateUrl: './players-list.component.html',
  styleUrls: ['./players-list.component.css']
})
export class PlayersListComponent implements OnInit {

  @Input() players = [];
  @Output() back = new EventEmitter();
  @Output() add = new EventEmitter();
  @Output() notListed = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onBack() {
    this.back.emit();
  }

  onAdd(player) {
    this.add.emit(player);
  }

  onNotListed() {
    this.notListed.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-player/players-list/players-list.component.ts